<mat-form-field floatLabel="never" fxFlex="100">
  <input
    #input
    placeholder="Search"
    matInput
    type="search"
    [(ngModel)]="value"
    (keyup)="applyFilter(input.value)"
    class="input-box"
  />
  <button
    mat-icon-button
    matSuffix
    color="primary"
    aria-label="search"
    (click)="applyFilter(input.value)"
  >
    <mat-icon>search</mat-icon>
  </button>
</mat-form-field>
